import { cssClass } from '@tableau/vizportalclient-common-components';
import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

export const samlProviderTextDescriptionStyle: React.CSSProperties = {
    width: 470,
    fontSize: 12,
    fontWeight: 350,
    fontFamily: 'BentonSans-Book',
    color: '#333333',
    lineHeight: '18px'
};

export const samlProviderTextTitleStyle: React.CSSProperties = {
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'BentonSans-Medium',
    color: '#333333',
    paddingBottom: 8
};

export const samlProviderMetaDataTextDescriptionStyle: React.CSSProperties = {
    ...samlProviderTextDescriptionStyle,
    fontSize: 14,
};

export const samlProviderMatchAttributesTitleStyle: React.CSSProperties = {
    fontWeight: 500,
    fontFamily: 'BentonSans-Medium',
    color: '#000000',
    paddingBottom: 8,
    fontSize: 12,
};

export const samlProviderExportMetadataLabelStyle: React.CSSProperties = {
    fontWeight: 500,
    fontFamily: 'BentonSans-Medium',
    color: '#000000',
    fontSize: 12,
};

export const samlProviderListStyle: React.CSSProperties = {
    ...samlProviderTextDescriptionStyle,
    paddingLeft: '0px',
    width: 450
};

export const samlProviderImportMetadataTextInput: React.CSSProperties = {
    height: '24px',
    width: 463
};

export const samlProviderExportMetadataTextInput: React.CSSProperties = {
    height: '24px',
    width: 445
};

export const samlProviderMatchAttributeTextInput: React.CSSProperties = {
    height: '24px',
    width: 435
};

export const samlProviderDarkHighlightTextStyle: React.CSSProperties = {
    fontWeight: 'bold'
};

export const samlDisabled: React.CSSProperties = {
    pointerEvents: 'none',
    opacity: CommonStyles.Opacity.DisabledOpacity,
    cursor: 'default'
};

export const samlTableTopPadding: React.CSSProperties = {
    paddingTop: 20
};

export const samlTableStyle: React.CSSProperties = {
    fontWeight: 'normal',
    fontSize: CommonStyles.Sizes.SmallFontSize
};

export const emailMappingTextBoxStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    display: 'table'
};

export const samlProviderGroupNumber: React.CSSProperties = {
    marginRight: TabStyles.Spacing.SmallSpace
};

export const samlProviderGroupButton: React.CSSProperties = {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: TabStyles.Spacing.SmallSpace,
    width: 470,
    fontSize: 12,
    fontWeight: 350,
    fontFamily: 'BentonSans-Book',
    color: '#333333',
};

export const samlProviderGroupContent: React.CSSProperties = {
    marginBottom: TabStyles.Spacing.MediumSpace
};

export const samlProviderGroupSettings: React.CSSProperties = {
    paddingBottom: TabStyles.Spacing.LargeSpace
};

export const samlProviderAlertText: React.CSSProperties = {
    paddingTop: 8,
    paddingBottom: 8
};

// copied from BulkImportUserDialogStyle.  Need to make specific drag and drop style settings
// for samlProvider
export const samlProviderdragAndDropContainer = cssClass('', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 463,
    height: '110px',
    marginBottom: '24px'
});